module.exports = __webpack_public_path__ + "img/heart.94517572.svg";